import type { FeatureFlagSwitcherConfig } from './types';

/**
 * Internal preset configs. Use string IDs in Example, e.g. featureFlagSwitchers={['labelling']}.
 */
const FINESSE_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-tokens-finesse',
	label: 'Finesse',
	defaultValue: false,
};

const FINESSE_SELECTED_STATE_PACKAGES = new Set([
	'@atlaskit/avatar-group',
	'@atlaskit/button',
	'@atlaskit/calendar',
	'@atlaskit/checkbox',
	'@atlaskit/dropdown-menu',
	'@atlaskit/dynamic-table',
	'@atlaskit/menu',
	'@atlaskit/navigation-system',
	'@atlaskit/radio',
	'@atlaskit/select',
	'@atlaskit/tabs',
]);

const MOTION_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_INPUT_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-input',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_SELECTION_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform_design_system_selection_radial_fade',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_LABELS_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-labels',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_MODAL_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-modal',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_POPUP_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-popup',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_SPOTLIGHT_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-spotlight',
	label: 'Motion',
	defaultValue: true,
};

const MOTION_UPLIFT_TABS_SWITCHER_CONFIG: FeatureFlagSwitcherConfig = {
	flagKey: 'platform-dst-motion-uplift-tab',
	label: 'Motion',
	defaultValue: true,
};

const FEATURE_FLAG_SWITCHER_PRESETS: Record<string, FeatureFlagSwitcherConfig> = {
	finesse: FINESSE_SWITCHER_CONFIG,
	motion: MOTION_SWITCHER_CONFIG,
	motionInput: MOTION_UPLIFT_INPUT_SWITCHER_CONFIG,
	motionLabels: MOTION_UPLIFT_LABELS_SWITCHER_CONFIG,
	motionSelection: MOTION_SELECTION_SWITCHER_CONFIG,
	motionModal: MOTION_UPLIFT_MODAL_SWITCHER_CONFIG,
	motionPopup: MOTION_UPLIFT_POPUP_SWITCHER_CONFIG,
	motionSpotlight: MOTION_UPLIFT_SPOTLIGHT_SWITCHER_CONFIG,
	motionTabs: MOTION_UPLIFT_TABS_SWITCHER_CONFIG,
};

/**
 * Resolves string IDs to feature flag switcher configs. Finesse is automatically included for
 * component packages affected by the selected-state changes. Unknown IDs are ignored.
 */
export function resolveFeatureFlagSwitchers(
	ids: string[],
	packageName?: string,
): FeatureFlagSwitcherConfig[] {
	const resolvedIds = FINESSE_SELECTED_STATE_PACKAGES.has(packageName ?? '')
		? [...ids, 'finesse']
		: ids;

	return [...new Set(resolvedIds)]
		.map((id) => FEATURE_FLAG_SWITCHER_PRESETS[id])
		.filter((config): config is FeatureFlagSwitcherConfig => config != null);
}
